function i(n){return Object.entries(n).reduce((e,[s,r])=>{const[,a,o]=s.split("."),t=r.toString().toLowerCase();return e[o]={enabled:t!==""&&t!=="false",value:r,namespace:a},e},{})}export{i as parseExperiments};
